export function enforceHttps(url: string): string {
  if (!url) return url;
  try {
    const u = new URL(url, typeof window !== 'undefined' ? window.location.origin : 'https://tamoaki.co.ao');
    // Não tentar forçar https para IPs sem certificado
    const isIp = /^\d+\.\d+\.\d+\.\d+$/.test(u.hostname);
    if (u.protocol === 'http:' && !isIp) {
      u.protocol = 'https:';
    }
    return u.toString();
  } catch {
    return url;
  }
}

export function sanitizeImageUrl(url: string): string {
  return enforceHttps(url);
}


